export default __webpack_public_path__ + "static/media/3.f77a6014.jpg";